import { ScheduleSpeakingClassesEvent } from "@/types";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import weekOfYear from "dayjs/plugin/weekOfYear";
import React from "react";
import SpeakingSuccessMessage from "../../ScheduleSuccessMessage";

dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);

const MobileConfirmation = ({
  events,
  onClose
}: {
  events: ScheduleSpeakingClassesEvent[] | null;
  onClose?: () => void;
}) => {
  return (
    <SpeakingSuccessMessage events={events as never} onClose={onClose} />
  );
};
export default React.memo(MobileConfirmation);